import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import React from "react";

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    }
}));

type Props = {
    open : boolean;
    message : string;
    onClose : () => void;
};

const MessageDialog : React.FC<Props> = ({open, message, onClose} : Props) =>{
    const classes = useStyles();

    return <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle disableTypography>
            <Typography variant="h6">Time Entry Problem</Typography>
            <IconButton className={classes.closeButton} onClick={onClose} airia-label="close">
                <CloseIcon/>
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <Typography>{message}</Typography>
        </DialogContent>
        <DialogActions>
            <Grid container>
                <Grid>
                    <Button onClick={onClose}>
                        Ok
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>;
}

export default MessageDialog;